<template>
  <v-dialog
    v-model="dialog"
    max-width="560"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="error"
        flat
        small
        :disabled="dialog || item.has_post > 0"
        v-on="on"
      >
        <v-icon left>
          delete
        </v-icon>
        Delete
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="headline">
        Deleting this image?
      </v-card-title>
      <v-card-text>You upload this logo. Deleting logo file it will be forever remove from database and storage</v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="grey"
          flat
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          color="error"
          flat
          :loading="isSubmitting"
          @click.stop="onSubmitForm"
        >
          Delete
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    dialog: false,
    isSubmitting: false
  }),
  methods: {
    ...mapActions({
      deleteImage: 'clientLogo/deleteImage'
    }),
    onSubmitForm () {
      this.isSubmitting = true
      this.deleteImage(this.item)
      .then((response) => {
        if (response === 204) {
          this.isSubmitting = false
          this.dialog = false
        }
      })
    }
  }
}
</script>
